import angular from 'angular';

class LogoutCtrl {
    /*@ngInject*/
    constructor($rootScope, AUTH_EVENTS, AuthSvc, SessionSvc) {
        this.$rootScope = $rootScope;
        this.AUTH_EVENTS = AUTH_EVENTS;
        this.AuthSvc = AuthSvc;
        this.SessionSvc = SessionSvc;
    }

    $onInit() {
        let vm = this;

        vm.currentUser = null;

        vm.logout = logout;

        ////////////////
        vm.$rootScope.$on(vm.AUTH_EVENTS.loginSuccess, function() {
            refreshCurrentUser();
        });
        vm.$rootScope.$on(vm.AUTH_EVENTS.logoutSuccess, function() {
            refreshCurrentUser();
        });
        refreshCurrentUser();

        function logout() {
            vm.AuthSvc.logout().then(function() {
                vm.$rootScope.$broadcast(vm.AUTH_EVENTS.logoutSuccess);
            });
        }

        function refreshCurrentUser() {
            vm.currentUser = vm.SessionSvc.getCurrentUser();
        }
    }
}

angular.module('app.login').component('logout', {
    templateUrl: require('./logout.html'),
    controller: LogoutCtrl
});
